import { h } from 'preact';
import { Button } from '../Button';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'Button',
  category: '🔘 Botões',
  description: 'Botão reutilizável com 5 variantes (primary, secondary, danger, ghost, success), 4 tamanhos, loading, ícone e fullWidth',
  usedIn: ['AgentesPage', 'ChatHubPage', 'Integrations', 'ReferralDashboard', 'Profile'],
  example: () => (
    <div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
        <Button variant="primary">Primary</Button>
        <Button variant="secondary">Secondary</Button>
        <Button variant="ghost">Ghost</Button>
        <Button variant="danger">Danger</Button>
        <Button variant="success">Success</Button>
        <Button variant="primary" disabled>Disabled</Button>
      </div>
      <div style={{ display: 'flex', gap: 8, marginTop: 12, alignItems: 'center' }}>
        <Button size="xs">XS</Button>
        <Button size="sm">SM</Button>
        <Button size="md">MD</Button>
        <Button size="lg">LG</Button>
      </div>
      <div style={{ display: 'flex', gap: 8, marginTop: 12, alignItems: 'center', flexWrap: 'wrap' }}>
        <Button loading={true}>Loading</Button>
        <Button icon="🔍">Com Icone</Button>
        <Button fullWidth variant="secondary">Full Width</Button>
      </div>
    </div>
  ),
};
